<template>
  <div class="violation-history">
    <div v-if="!records.length" class="empty-history">Chưa có</div>
    <article v-for="record in records" :key="record.id" class="history-card">
      <header>
        <div><strong>{{ record.violation_type === FRAUD ? 'Xử lý gian lận' : 'Vi phạm quy chế' }} #{{ record.id }} | {{ record.created_by }} </strong> đã ghi nhận {{ record.violation_type_name.toLowerCase() }}</div>
        <time :datetime="record.created_at">{{ formatTime(record.created_at) }}</time>
      </header>
      <dl>
        <dt>Học viên:</dt><dd>{{ studentLabel(record.student) }}</dd>
        <dt>Loại vi phạm:</dt><dd>{{ record.violation_type_name }}</dd>
        <template v-if="record.violation_type === REGULATION">
          <dt>Kĩ năng vi phạm:</dt><dd>{{ record.skills.map(skill => skill.name).join(', ') }}</dd>
        </template>
        <dt>Hành vi vi phạm:</dt>
        <dd><div v-for="reason in record.reasons" :key="reason.id">{{ reason.reason || 'Không có' }}</div><span v-if="!record.reasons.length">Không có</span></dd>
        <dt>Chi tiết hành vi:</dt><dd class="verbatim">{{ record.description || 'Không có' }}</dd>
        <dt>Bằng chứng:</dt>
        <dd><a class="link" v-if="safeLink(record.evidence)" :href="safeLink(record.evidence)" target="_blank" rel="noopener noreferrer">{{ record.evidence }}</a><span v-else class="verbatim">{{ record.evidence }}</span></dd>
        <dt>Record xử lý:</dt>
        <dd><a class="link" v-if="safeLink(record.handling_record)" :href="safeLink(record.handling_record)" target="_blank" rel="noopener noreferrer">{{ record.handling_record }}</a><span v-else class="verbatim">{{ record.handling_record }}</span></dd>
      </dl>
    </article>
  </div>
</template>

<script>
import moment from 'moment';
import { FRAUD, REGULATION, violationStudentLabel, violationLink } from '@/core/option/examViolation';
export default {
  name: 'ViolationHistory',
  props: { records: { type: Array, default: () => [] } },
  data() {
    return { FRAUD, REGULATION };
  },
  methods: {
    studentLabel: violationStudentLabel,
    safeLink: violationLink,
    formatTime(value) { return moment(value).format('HH:mm:ss DD-MM-YYYY'); }
  }
};
</script>

<style scoped>
.violation-history { min-height: 540px; }
.empty-history { padding: 40px 0; color: #667085; font-size: 14px; line-height: 22px; text-align: center; }
.history-card { padding: 14px; margin-bottom: 12px; border: 1px solid #d9d9d9; border-radius: 2px; color: #303846; font-size: 14px; line-height: 1.65; }
.history-card header { display: flex; justify-content: space-between; gap: 16px; border-bottom: 1px solid #d9d9d9; padding-bottom: 16px; margin-bottom: 16px; color: #5e00b6; }
.history-card strong { font-weight: 600; }
.history-card time { flex-shrink: 0; color: #667085; font-size: 13px; font-style: italic; }
.history-card dl { display: grid; grid-template-columns: 122px minmax(0, 1fr); gap: 8px 12px; margin: 0; }
.history-card dt { color: #465268; font-weight: 500; }
.history-card dd { margin: 0; overflow-wrap: anywhere; }
.history-card a.link { color: #06f; font-size: 14px; }
.verbatim { white-space: pre-wrap}
@media (max-width: 600px) {
  .history-card { padding: 12px; }
  .history-card header { flex-direction: column; gap: 4px; }
  .history-card dl { grid-template-columns: 1fr; gap: 4px; }
  .history-card dt { font-weight: 500; margin-top: 8px; }
}
</style>
